<template>
  <div
    v-if="artifactsStore.selectionMode && artifactsStore.hasOcrData"
    class="absolute pointer-events-auto z-10"
    @click.stop
    :style="{
      top: `${props.imageBounds.top}px`,
      left: `${props.imageBounds.left}px`,
      width: `${props.imageBounds.width}px`,
      height: `${props.imageBounds.height}px`,
    }"
    data-testid="ocr-overlay"
  >
    <TextSelectRegion
      v-for="(line, index) in artifactsStore.ocrLines"
      :key="index"
      :line="line"
      :index="index"
      :selected="artifactsStore.selectedLineIndices.includes(index)"
    />
  </div>
</template>

<script setup lang="ts">
import { useArtifactsStore } from '../../store/useArtifactsStore';
import TextSelectRegion from './TextSelectRegion.vue';
import type { ImageBounds } from '../../composables/useImageBounds';

const props = defineProps<{
  imageBounds: ImageBounds;
}>();

const artifactsStore = useArtifactsStore();
</script>
